/* Copyright (c) 2023-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Types } from 'bridge-commands/types';

export import SendExceptionInfoParameters = Types.Common.Diagnostics.SendExceptionInfoParameters;
export import ExceptionInfo = Types.Common.Diagnostics.ExceptionInfo;
export import ClientInfo = Types.Common.Diagnostics.ClientInfo;

export import SendUserFeedbackInfoParameters = Types.Common.Diagnostics.SendUserFeedbackInfoParameters;

export enum ComponentName {
    NvApp = 'NVAPP_UI',
    OSC = 'NVAPP_OSC_UI',
    GFN = 'GFN_UI'
}
